import styled from '@emotion/styled';
import { fromTheme } from '@kyruus/ui-theme';
import { LIST_VIEW_MODE } from 'Common/config';

export const ProviderCardWrapper = styled.div`
  container-name: provider-card;
  container-type: inline-size;
`;

export const ProviderCardListContainer = styled.div`
  container-name: provider-card-list;
  container-type: inline-size;
`;

export const ProviderCardList = styled.div<{
  mode: 'list' | 'grid' | 'modern-grid';
  providerCardsPerRow?: number;
}>`
  margin-bottom: ${fromTheme('spacing_xlarge')};

  ${(props) => {
    if (props.mode === LIST_VIEW_MODE.LIST) {
      return `
        display: flex;
        flex-direction: column;
        row-gap: ${fromTheme('spacing_medium')(props)};
      `;
    }

    if (props.mode === LIST_VIEW_MODE.MODERN_GRID) {
      return `
        --grid-column-count: ${props.providerCardsPerRow ?? 3};
        --grid-layout-gap: ${fromTheme('spacing_large')(props)};
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(max(calc((100% - (var(--grid-column-count) - 1) * var(--grid-layout-gap)) / var(--grid-column-count)), 22ch), 1fr));
        gap: var(--grid-layout-gap);
        > div > div {
          height: 100%;
          > div {
            height: 100%;
          }
        }

        & .ProviderCard--ctas:has(> div:empty) {
          display: none;
        }
        & .ProviderCard--badge .MuiChip-label.MuiChip-labelSmall {
          color: inherit !important;
        }
      `;
    }

    const minGridCardSize = '425px';
    return `
      display: flex;
      flex-direction: column;
      row-gap: ${fromTheme('spacing_medium')(props)};

      @container provider-card-list (width >= ${minGridCardSize}) {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(${minGridCardSize}, 1fr));
        gap: ${fromTheme('spacing_medium')(props)};
        align-items: stretch;

        .provider-card {
          height: 100%;

          > div {
            height: 100%;
            grid-template-rows: auto;
          }
        }

        @container provider-card (width < 600px) {
          .booking-actions,
          .booking-availability-tiles,
          .provider-card-locations {
            align-content: end;
          }
        }
      }
    `;
  }}
`;
